export const FALLBACKS = {
  VIEWPORT_HEIGHT: 0,
  VIEWPORT_WIDTH: 0,
  WIDGET_HEIGHT: 120,
  CONTAINER_PADDING: 48,
} as const;
